import type { FieldDataType } from "~/graphql/supergraphTypes";

export const getFieldDataTypeLabel = (
  fieldType: FieldDataType | null | undefined,
): string | null => {
  switch (fieldType) {
    case "TEXT":
      return "Text";
    case "DATE":
      return "Date";
    case "QUANTITY":
      return "Quantity";
    case "VALUE":
      return "Value";
    case "PERCENTAGE":
      return "Percentage";
    default:
      return null;
  }
};
